import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';

export interface ColumnProps {
  name: string;
  tooltipText?: string;
  hideMobile?: boolean;
  mobileSortOrder?: number;
  center?: boolean;
}

export const RootineTableColumn = (props: ColumnProps): JSX.Element => {
  return (
    <Grid item xs={12} fontSize={12}>
      <Typography variant="mono" sx={{ opacity: 0.5 }}>
        {props.name}
      </Typography>
      {props.tooltipText && (
        <Tooltip title={props.tooltipText} placement="top" arrow>
          <InfoOutlinedIcon
            color="info"
            sx={{ position: 'relative', bottom: 5, left: 5, fontSize: '1rem' }}
          />
        </Tooltip>
      )}
    </Grid>
  );
};
